import { render, staticRenderFns } from "./UpdateLoans.vue?vue&type=template&id=b0fb56f6"
import script from "./UpdateLoans.vue?vue&type=script&lang=js"
export * from "./UpdateLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports